import { render, staticRenderFns } from "./TagBaler.vue?vue&type=template&id=8758299e&scoped=true"
import script from "./TagBaler.vue?vue&type=script&lang=js"
export * from "./TagBaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8758299e",
  null
  
)

export default component.exports